import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import DefaultButton from '../../../../global/default-button/default-button';
import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { IEventLinkDTO, IEventLinkType } from '../../../../../api/event-links.dao';
import { getFormattedUrl } from '../../../../../infrastructure/utils/common.utils';
import { CreateEventLinkType, EventLinksViewModel } from './event-links.viewmodel';
import { makeEventLinkFormInPopover } from './make-event-link-form-in-popover';
import { EventLinkItem } from './event-link-item/event-link-item';
import './event-links.scss';

type Props = {
    vm: EventLinksViewModel;
};

export const OpenFormInPopOverBtn = makeEventLinkFormInPopover(
    React.forwardRef((props: { isOpen: boolean }, ref: React.Ref<HTMLInputElement>) => {
        return <DefaultButton
            ref={ref}
            text={<FormattedMessage id='oe.common.addEventLink' description='button label' defaultMessage='+ Add Link' />}
            className={classnames('event_form__items-section__add-button', { 'active': props.isOpen })}
        />;
    })
);

export const EventLinksView = observer((props: Props): JSX.Element => {
    const { vm } = props;

    const formProps = {
        types: vm.linkTypes
    };

    const formattedSubdomain = getFormattedUrl(vm.passportSubdomain || '');

    const subdomain: IEventLinkDTO = {
        linkId: null,
        type: '',
        label: 'Passport',
        url: formattedSubdomain
    };

    const getEventLinks = () => {
        return vm.eventLinks.map(link => <EventLinkItem
            key={link.linkId}
            isEventTrackerForm={vm.isEventTrackerForm}
            onDelete={()=>vm.onDeleteLink(link)}
            vm={vm}
            {...link}
        />
        );
    };

    return (
        <div className={classnames('event_form__items-section', { 'event_form__list-view': vm.isEventTrackerForm })} >
            {!vm.isEventTrackerForm && <div className='event_form__items-section__title'>
                <FormattedMessage id='oe.common.eventLinks' description='Title text' defaultMessage='Links' />
            </div>
            }
            <div className='event_form__items-section__selected-items'>
                {vm.isEventTrackerForm && vm.passportSubdomain &&
                    <EventLinkItem
                        key={null}
                        isEventTrackerForm={vm.isEventTrackerForm}
                        {...subdomain}
                    />}
                { !vm.isEventTrackerForm && !vm.eventLinks.length
                    && <div className='event_form__items-section__message'>
                        <FormattedMessage
                            id='oe.event.noEventLinks'
                            description='Placeholder text'
                            defaultMessage='Event has no assigned links'
                        />
                    </div>
                }
                {getEventLinks()}
            </div>
            <div className={classnames(vm.isEventTrackerForm && 'event-tracker-add-link')}>
                 <OpenFormInPopOverBtn
                    formProps={formProps}
                    onApply={async (link: CreateEventLinkType) => {
                        vm.onAddEventLink(link);
                        if (vm.isEventTrackerForm) await vm.fetchEventsList();
                    }}
                    onCancel={vm.closeAddLinksPopup}
                />
            </div>

        </div>
    );
});

type ContainerProps = {
    links: IEventLinkDTO[];
    accountId: number;
    eventId: number;
    subdomain?: string | null;
    isEventTrackerForm?: boolean;
    fetchEventsList?: () => Promise<void>;
    eventLinkTypes?: IEventLinkType[];
};
const EventLinksContainer = withViewModel(EventLinksView, async (props: ContainerProps) => {
    const vm = new EventLinksViewModel(props);
    await vm.initialize();

    return vm;
});

export { EventLinksContainer as EventLinks };
